import React           from 'react';
import { useNavigate } from 'react-router-dom';
import usePOST         from 'rest/usePOST';
import useStyles       from './massActivateCardsPageStyles';

import Alert                 from 'components/Alert';
import NavBar                from 'NavBar';
import MassActivateCardsForm from './MassActivateCardsForm';
import Paper                 from '@mui/material/Paper';
import ResultNotification    from 'components/ResultNotification';

import createRestRequestConfig from 'rest/createRestRequestConfig';

import { AuthContext }              from 'App';
import { FINTECH_PATHS }            from 'rest/const';
import { HIDDEN_TABS }              from 'rest/const';
import internalPaths                from 'routing/internalPaths';


function MassActivateCardsPage() {

  const navigate    = useNavigate();
  const { classes } = useStyles();

  React.useEffect(() => { //REACT complained that I should do it in useEffect and not on first render
    if (HIDDEN_TABS.massActivateCards) { //Someone might know URL and try to access it directly
      navigate(internalPaths.login);
    }
  }, [navigate]);

  const { userInfo } = React.useContext(AuthContext);

  const [errorAlert,   setErrorAlert]   = React.useState(undefined);
  const [successAlert, setSuccessAlert] = React.useState(undefined);
  const [submitData,   setSubmitData]   = React.useState(undefined);

  const axiosCfg = createRestRequestConfig(userInfo.accessToken, true);

  function onRestSuccess(res) {
    const status    = res.status;
    const isSuccess = status >= 200 && status < 300;
    if (!isSuccess) {
      onRestError(res);
      return;
    }

    setSuccessAlert({
      msgTranslKey:          'success',
      msgTranslSecondaryKey: 'massActivateCardsFormSuccess',
      type:                  'success'
    });
    setSubmitData(null);

    if (process.env.NODE_ENV === 'development') {
      console.log('MassActivateCardsPage, onRestSuccess: ', res.data);
    }
  }

  function onRestError(err) {
    setErrorAlert({
      msgTranslKey:          'serverError',
      msgTranslSecondaryKey: 'massActivateCardsFormError',
      type:                  'error'
    });
    setSubmitData(null); //to prevent resending them on rerender

    if (process.env.NODE_ENV === 'development') {
      console.log('MassActivateCardsPage, onRestError: ' + (err.response || err).data);
      console.error('MassActivateCardsPage, onRestError: ' + err);
    }
  }

  const swrOptions = {
    shouldRetryOnError: false,
    onSuccess:          onRestSuccess,
    onError:            onRestError,
  };
  const path = submitData ? FINTECH_PATHS.massActivateCards.replace('{cardGroupId}', submitData.cardGroupId) : null;

  const { isValidating, mutate } = usePOST(path, submitData, axiosCfg, swrOptions);

  function handleSubmit(data) {
    setSubmitData(data);
    mutate();
  }

  function reset() {
    setErrorAlert(null);
    setSuccessAlert(null);
    setSubmitData(null);
  }

  //form is hidden instead being removed in order to preserve its state
  return (
    <>
      <NavBar/>
      <Paper elevation={3} className={classes.paper}>
        <div hidden={successAlert != null}>
          <MassActivateCardsForm onSubmit={handleSubmit} disabled={isValidating}/>
          <Alert alert={errorAlert} setAlert={setErrorAlert}/>
        </div>
        <ResultNotification
          alert={successAlert}
          reset={reset}
        />
      </Paper>
    </>
  );
}

export default MassActivateCardsPage;
